import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BookingSearchParameters } from 'app_sasha/shared/models/BookingSearchParameters';
import { SashaBreadcrumbService } from 'app_sasha/shared/components/breadcrumb/sasha-breadcrumb.service';
import { ViewsService } from 'libraries/view/views.service';
import { AppRootService } from 'app/shared/services/app-root/app-root-service';
import { SashaPageComponent } from '../sasha-page.component';
import { IBookingSearchParametersURL } from 'libraries/interfaces/IBookingSearchParameters';
import { TitleService } from 'app_sasha/shared/services/title/title.service';
import { Yii } from 'libraries/interfaces/Yii';
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";

@Component({
    selector: 'booking-search',
    template: `
        <div class="app-wrapper app-sasha">
            <sasha-breadcrumb></sasha-breadcrumb>
            <booking-search-form [searchParameters]="searchParameters"
                                 [focusOnInit]="true"
                                 (onBookingSearchSubmit)="onSubmit($event)"
                                 (reset)="onReset()"></booking-search-form>
        </div>`
    ,

    styles: [`
        .app-wrapper {
            max-width: 100%;
            margin-left: .75rem;
            margin-right: .75rem;
        }
    `]
})
export class BookingSearchComponent extends SashaPageComponent implements OnInit, OnDestroy {

    public searchParameters: BookingSearchParameters = new BookingSearchParameters();
    private queryParamsSubscription: Subscription;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly sashaBreadcrumbService: SashaBreadcrumbService,
        private readonly router: Router,
        protected views: ViewsService,
        appRootService: AppRootService,
        private readonly titleService: TitleService,
        private readonly errorTracingService: ErrorTracingService
    ) {
        super(views, appRootService);
    }

    public ngOnInit(): void {
        super.ngOnInit();

        this.titleService.setTitle(Yii.t("wui-sasha-js", "Recherche de dossiers"));

        this.queryParamsSubscription = this.route
            .queryParams
            .pipe(
                tap((params: IBookingSearchParametersURL) => {
                    this.searchParameters = BookingSearchParameters.fromRouteParams(params);
                    this.sashaBreadcrumbService.setSearch(this.searchParameters);
                })
            )
            .subscribe();
    }

    public onSubmit(searchParametersEvent: BookingSearchParameters): void {
        const params: IBookingSearchParametersURL = searchParametersEvent.convertToUrlParameters();
        // first refresh the '/search/' url with parameters
        // necessary to correctly use browser navigation
        this.router.navigate(
            ['/sasha/booking/search'], {queryParams: params}
        ).then(// then change route to reach '/search-result/'
            async () => this.router.navigate(
                ['/sasha/booking/search-result'], {queryParams: params}
            )
        ).catch((reason: boolean) => {
            this.errorTracingService.captureException(reason);
        });
    }

    public ngOnDestroy(): void {
        if (this.queryParamsSubscription) {
            this.queryParamsSubscription.unsubscribe();
        }
    }

    public onReset(): void {
        const params: BookingSearchParameters = new BookingSearchParameters();

        this.router.navigate(
            ['/sasha/booking/search'],
            {queryParams: params.convertToUrlParameters()}
        ).catch((reason: boolean) => {
            this.errorTracingService.captureException(reason);
        });
    }
}
